// Переключатель: true — блокувати доступ з ПК, false — пускати всіх (зручно для розробки на десктопі)
export const BLOCK_DESKTOP = true;

export function isMobileDevice() {
  const ua = window.navigator.userAgent;
  const isMobileUA = /android|iphone|ipod|iemobile|blackberry|opera mini|mobile/i.test(ua);
  // iPadOS 13+ за замовчуванням видає себе за "Macintosh" в UA
  const isIpad = /ipad/i.test(ua) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
  return isMobileUA || isIpad;
}
